module.exports = __webpack_public_path__ + "static/media/feature-check.982fe54e.svg";